import { render, staticRenderFns } from "./Priorities.vue?vue&type=template&id=5fd72832&scoped=true"
import script from "./Priorities.vue?vue&type=script&lang=ts"
export * from "./Priorities.vue?vue&type=script&lang=ts"
import style0 from "./Priorities.vue?vue&type=style&index=0&id=5fd72832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd72832",
  null
  
)

export default component.exports